import React, { useEffect } from "react";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import LearnMore from "../../../../components/learnMore/learnMore";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/numberOfActiveMembersBySagas";
import PropTypes from "prop-types";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import LineOrTableChart from "./smartComponents/LineOrTableChart";
import PeriodType from "./smartComponents/PeriodType";
import TableChart from "./smartComponents/TableChart";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import TotalMembersCount from "./smartComponents/TotalMembersCount";
import { ScoreCards } from "./smartComponents/scoreCards";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import CustomFilters from "./smartComponents/CustomFilters";
import PosTable from "./smartComponents/PosTable";
import "./numberOfActiveMembersByModule.css.scss";

export const NumberOfActiveMembersByModule = ({ params, learnMore }) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.numberOfActiveMembersBy.isLoading);
  const updatesLoading = useSelector((state) => state.numberOfActiveMembersBy.updatesLoading);

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(params));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="total-filter">{updatesLoading ? "" : <TotalMembersCount />}</div>
          <div className="top-filter">
            <div>
              <div className="top-filter__left">{params.filtersUrl && <CustomFilters />}</div>
            </div>
            <div className="top-filter__right">
              <div className="select-box-no-width">
                <p>Period Type</p>
                <PeriodType />
              </div>

              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>
              <div className="date-select-box select-box-no-width multi">
                <p>Date</p>
                <DatePicker />
              </div>
              <UpdateButtons />
            </div>
          </div>
        </div>

        <div data-testid="charts-container" className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <>
              <LineOrTableChart />
              <div className="add-color">
                <TableChart />
              </div>
              <ScoreCards />
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div id="numberOfActiveMembersByModule-root">
      <SectionToggle
        autoHeight
        paddingBottom={0}
        height={690}
        title={params.sectionName}
        learnMore={
          <div className="information-buttons-wrapper">
            {getLearnMoreButton(learnMore)}
            {getMoreInfoButton(params?.membership_metric)}
          </div>
        }
        isLoading={isLoading}
        content={content()}
      />
    </div>
  );
};

const getMoreInfoButton = (membershipMetric) => {
  const moreInfoProps = {
    learnMoreId: "membership_module_pos_table",
    title: "Packages tracked as membership",
    content: <PosTable />,
    additionalInfo: true,
    customStyles: {
      maxHeight: "initial"
    },
    testId: "additionalInfoButton"
  };

  return membershipMetric !== "NumberOfMembersByProfile" ? <LearnMore {...moreInfoProps} /> : null;
};

const getLearnMoreButton = (props) => {
  const { learnMoreId, title, content, html, link, disable } = props;
  const learnMoreProps = {
    html,
    learnMoreId,
    title,
    content,
    link
  };

  return disable ? null : <LearnMore {...learnMoreProps} />;
};

NumberOfActiveMembersByModule.propTypes = {
  params: PropTypes.object,
  learnMore: PropTypes.object
};
